// extracted by mini-css-extract-plugin
export default {"popup":"popUp_popup__1OuZY","back":"popUp_back__DAKYa","text":"popUp_text__XfUdk","turnoff":"popUp_turnoff__r-Cks"};